import styled from 'styled-components';
import { Typography } from '@sky-distribution/react-commons-ui';

export const TitleStyled = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.header};
  font-size: 3rem;
  font-weight: 800;
  text-align: center;
  margin: 2rem auto;
  max-width: 46rem;

  ${({ theme }) => theme.down(theme.breakpoints.smd)} {
    margin: 1rem;
    font-size: 1.1875rem;
    text-align: left;
    max-width: 100%;
  }
`;
